@if (nativeLookAndFeel) {
  <ion-item>
    <ion-checkbox
      class="shared-ui-checkbox"
      [checked]="checked"
      (checkedChange)="onChange($event)"
      (ionChange)="onChange($event)"
      labelPlacement="floatingLabel ? 'stacked' : 'start'"
      (ionFocus)="onFocus($event)"
      (ionBlur)="onBlur()"
      [ariaLabel]="ariaLabel"
      #checkbox
      >{{ label }}</ion-checkbox
    >
  </ion-item>
} @else if (tailwind) {
  <div class="tw-pb-1">
    @if (label) {
      <label class="tw-py-2" [ariaLabel]="ariaLabel" [for]="id">{{ label }}</label>
    }
    <input
      #checkbox
      class="shared-ui-checkbox"
      [id]="id"
      type="checkbox"
      [checked]="checked"
      (change)="onChange($event)"
      (focus)="onFocus($event)"
      (blur)="onBlur()"
      [required]="required"
      [disabled]="disabled"
      class="tw-bg-white tw-border tw-border-solid tw-border-gray-100 tw-text-gray-900 tw-text-sm tw-rounded-md focus:tw-outline-none focus-visible:tw-outline-none focus:tw-border-primary focus-visible:tw-border-primary tw-block tw-w-full tw-p-2 dark:tw-bg-gray-700 dark:tw-border-gray-600 dark:tw-placeholder-gray-400 dark:tw-text-white dark:focus:tw-ring-primary dark:focus:tw-border-primary dark:focus-visible:tw-ring-primary dark:focus-visible:tw-border-primary"
    />
  </div>
} @else {
  @if (label) {
    <label [for]="id">{{ label }}</label>
  }
  <input
    #checkbox
    class="shared-ui-checkbox"
    [id]="id"
    type="checkbox"
    [checked]="checked"
    (change)="onChange($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur()"
    [required]="required"
    [disabled]="disabled"
    class="form-control"
  />
}
